import React from 'react';
import { Link } from 'react-router-dom';
import {
  getTrackingConsent,
  setTrackingConsent,
  type TrackingConsentRecord,
} from '@/lib/privacy-consent';

export function ConsentBanner() {
  const [consent, setConsent] = React.useState<TrackingConsentRecord | null>(() =>
    getTrackingConsent()
  );

  if (consent) return null;

  return (
    <aside
      aria-label="Privacy choices"
      className="fixed inset-x-3 bottom-3 z-[80] mx-auto max-w-4xl rounded-lg border border-slate-700 bg-slate-950/95 p-4 text-white shadow-2xl backdrop-blur md:bottom-5"
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-sm font-black">Privacy choices</p>
          <p className="mt-1 text-xs leading-5 text-slate-300">
            We use essential storage for login and gameplay. Optional tracking measures referrals,
            sponsor clicks, and product analytics. Browser opt-out signals default to essential-only.
          </p>
          <Link
            to="/privacy-choices"
            className="mt-2 inline-flex text-xs font-bold text-emerald-300 hover:text-emerald-200"
          >
            Manage privacy choices
          </Link>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={() => setConsent(setTrackingConsent('denied'))}
            className="min-h-10 rounded-lg border border-slate-600 px-4 py-2 text-sm font-bold text-slate-200 transition hover:border-slate-400 hover:text-white"
          >
            Essential Only
          </button>
          <button
            type="button"
            onClick={() => setConsent(setTrackingConsent('granted'))}
            className="min-h-10 rounded-lg bg-emerald-400 px-4 py-2 text-sm font-black text-slate-950 transition hover:bg-emerald-300"
          >
            Allow Tracking
          </button>
        </div>
      </div>
    </aside>
  );
}

export default ConsentBanner;
